export default __webpack_public_path__ + "static/media/ret-patio.1402a1cf.jpeg";